// extracted by mini-css-extract-plugin
module.exports =  {"seller-info":"GXMqL8K","sellerInfo":"GXMqL8K","compact-view":"WRmFq41","compactView":"WRmFq41","separation-ellipse":"WG0af1L","separationEllipse":"WG0af1L"};